import { getInstance } from './instance';

const instance = getInstance();

export const getGhlWebsiteByDraft = (draftId) => {
  const url = `/ghl/websites/by-draft/${draftId}`;
  return instance
    .get(url)
    .then((response) => response.data)
    .catch((error) => {
      const status = error?.response?.status;
      if (status !== 404) {
        console.warn(`getGhlWebsiteByDraft failed [${status ?? 'network'}] ${url}`, error?.response?.data ?? error?.message);
      }
      return null;
    });
};
